import { Component } from '@angular/core';

/**
 * Nenhum rodapé fixo foi observado nas telas percorridas do portal-hml.affixtech.com.br
 * (21/08/2026) — o conteúdo das páginas analisadas não exigiu rolagem até o fim. Este
 * componente é um placeholder mínimo; confirmar com o time se existe um rodapé com
 * central de atendimento antes de expandir.
 */
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  readonly currentYear = new Date().getFullYear();
}
